module.exports = __webpack_public_path__ + "assets/icons/ic_chevron_right_24px.svg";